export const postSecondaryCareerChecklistItems = [
  {
    key: 'secCareerHSRequirement',
    label:
      '*If a HS diploma/GED is required prior to the application process, steps will be discussed/planned for implementation, with the Successful Futures Specialist, after the diploma/GED is obtained.',
    confirmKey: 'confirmSecCareerHSRequirement',
    points: 0,
    due: '1st Senior Planning Meeting',
    type: 'instruction',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerExploreOptions',
    label: 'Explore and visit Career Training options that best fit your areas of interest, as well as your strengths.',
    confirmKey: 'confirmSecCareerExploreOptions',
    points: 0,
    due: '1st Senior Planning Meeting',
    type: 'instruction',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerStartDates',
    label: '33. Research the start dates that the programs offer - how do these start dates align with graduation dates?',
    confirmKey: 'confirmSecCareerStartDates',
    points: 3,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerSubmitApps',
    label: '34. Submit 2-3 applications to the programs you are most interested in and are the best fit for you.',
    confirmKey: 'confirmSecCareerSubmitApps',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerFinancial',
    label:
      '35. Look into the financial cost of the training programs that you are interested in. Are there opportunities to apply for scholarships or other forms of financial assistance? Write down the options that are offered to help pay for the training.',
    confirmKey: 'confirmSecCareerFinancial',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerAcceptFAFSASupport',
    label: '36. Does the training program accept grants/loans offered by completing the FAFSA? (If yes, complete items 38-40 below.)',
    confirmKey: 'confirmSecCareerAcceptFAFSASupport',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerFASID',
    label:
      '37. a) Go to FAFSA.ed.gov and create a Federal Student Aid Account. (one for you and one for a parent, if applicable.) It may be easiest to have a parent create their FAFSA ID first and then create your FAFSA ID.',
    confirmKey: 'confirmSecCareerFASID',
    points: 1,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerCompleteFAFSA',
    label: '38. b) Complete the FAFSA on or after October 1st.',
    confirmKey: 'confirmSecCareerCompleteFAFSA',
    points: 1,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerLocateStudentAidRpt',
    label: '39. c) Confirm you received a Student Aid Index (SAI) in your email.',
    confirmKey: 'confirmSecCareerLocateStudentAidRpt',
    points: 1,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerExploreHousing',
    label:
      '40. Where will you live while you are enrolled in this training program? Explore Housing opportunities and list two options that are close to the training program and are realistic for your situation.',
    confirmKey: 'confirmSecCareerExploreHousing',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerIdentifyTransportation',
    label: '41. You will need transportation to and from the training program every day. Identify 2 affordable options for transportation.',
    confirmKey: 'confirmSecCareerIdentifyTransportation',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerTools',
    label:
      '42. Look at the required equipment necessary prior to starting the training program. Make a list of any tools you will need. Develop a plan for how you will get the necessary tools.',
    confirmKey: 'confirmSecCareerTools',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerBudget',
    label: '43. Create a budget that you will use after graduation when you start in this program.',
    confirmKey: 'confirmSecCareerBudget',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerNecessaryInfo',
    label:
      '44. Once accepted, ask for any necessary information (example: student ID/password) to log into an account for further information. Store any necessary/private information in your senior binder.',
    confirmKey: 'confirmSecCareerNecessaryInfo',
    points: 3,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerSendDeposits',
    label: '45. Submit any deposits necessary to hold/secure your application and ensure your start date is held for you.',
    confirmKey: 'confirmSecCareerSendDeposits',
    points: 2,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerHousingApps',
    label: '46. Complete applications for housing.',
    confirmKey: 'confirmSecCareerHousingApps',
    points: 3,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerPartTimeJobs',
    label:
      '47. Will you need a part time job while attending this training program to pay for your living expenses? If “yes” then find and apply for at least 3 part-time jobs that fit the schedule of the training program and are near the location of where you will be living.',
    confirmKey: 'confirmSecCareerPartTimeJobs',
    points: 2,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secCareerPlanDates',
    label: '48. Identify and plan start dates for the program and job (if necessary) and a move-in date for your housing.',
    confirmKey: 'confirmSecCareerPlanDates',
    points: 3,
    due: 'April - May',
    minVersion: 1,
    maxVersion: 1,
  },
];
